import * as Configuration from '../../app.constants.js';


export class PasswordConfirmService {
  constructor($http) {
    this._$http = $http;
  }

  get(companyId, confirmationId, confirmationUid) {
    return this._$http.get(Configuration.constants.baseUrl + companyId + '/password-confirm/' + confirmationId + '/' + confirmationUid);
  }
  set(companyId, confirmationId, confirmationUid, password) {
    return this._$http.post(Configuration.constants.baseUrl + companyId + '/password-confirm/' + confirmationId + '/' + confirmationUid,
      {password : password});
  }


  static PasswordConfirmFactory($http) {
    return new PasswordConfirmService($http);
  }
}
PasswordConfirmService.PasswordConfirmFactory.$inject = ['$http'];

